module.exports = __webpack_public_path__ + "static/tat-19-6775b7e139e88fa50a875f124e3a504a.jpg";